import { SectionMessage } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { CheckResult } from "../types";
import { caseHasComplianceReviewHold } from "../review-hold/utils";

interface Props {
  cancellationReason?: string | null;
  checks?: CheckResult[];
}

export function CaseMessages(props: Props) {
  const { t } = useTranslation();
  const { cancellationReason, checks = [] } = props;
  const showComplianceReviewBanner = caseHasComplianceReviewHold(checks);
  const complianceReviewHoldMessage = t(
    "This check is complete. The result is being held as part of a compliance review for this case, and will be released automatically once that review is finished."
  );

  if (!cancellationReason && !showComplianceReviewBanner) {
    return null;
  }

  return (
    <div className={styles.messages}>
      {cancellationReason && (
        <SectionMessage
          icon="error"
          type="danger"
          sectionTitle={t("Case cancelled")}
        >
          {cancellationReason}
        </SectionMessage>
      )}
      {showComplianceReviewBanner && (
        <SectionMessage
          type="default"
          icon="info"
          sectionTitle={t("Compliance review")}
          testID="compliance-review-case-banner"
        >
          {complianceReviewHoldMessage}
        </SectionMessage>
      )}
    </div>
  );
}

const styles = {
  messages: css({
    display: "grid",
    gap: "var(--space-4)",
    marginBottom: "var(--space-4)",
  }),
};
